const Download = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="33"
    height="32"
    viewBox="0 0 33 32"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.5 10.6055C17.0523 10.6055 17.5 11.0532 17.5 11.6055V21.1755C17.5 21.7278 17.0523 22.1755 16.5 22.1755C15.9477 22.1755 15.5 21.7278 15.5 21.1755V11.6055C15.5 11.0532 15.9477 10.6055 16.5 10.6055Z"
      fill="#00A1ED"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.0151 18.2504C21.4056 18.6409 21.4056 19.274 21.0151 19.6646L17.1381 23.5416C16.9506 23.7291 16.6962 23.8344 16.431 23.8344C16.1658 23.8344 15.9114 23.7291 15.7239 23.5415L11.9849 19.8026C11.5944 19.412 11.5944 18.7789 11.9849 18.3883C12.3755 17.9978 13.0086 17.9978 13.3992 18.3884L16.431 21.4202L19.6009 18.2503C19.9914 17.8598 20.6246 17.8598 21.0151 18.2504Z"
      fill="#00A1ED"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.80351 5.28273C10.2564 5.09508 10.7418 4.99854 11.232 4.99854H19.032V5.99854L19.0334 4.99854C19.3533 4.99898 19.6699 5.06249 19.9652 5.18537C20.2601 5.3081 20.5281 5.4877 20.7537 5.714C20.754 5.71427 20.7542 5.71454 20.7545 5.71481L24.7871 9.74742C25.0132 9.97345 25.1924 10.2418 25.3148 10.5371C25.4371 10.8325 25.5 11.149 25.5 11.4685V23.8915C25.5 24.8813 25.1068 25.8306 24.4069 26.5304C23.7071 27.2303 22.7578 27.6235 21.768 27.6235H11.232C10.2422 27.6235 9.29298 27.2303 8.59313 26.5304C7.89328 25.8306 7.5 24.8814 7.5 23.8915L7.5 8.7319C7.5 8.73178 7.5 8.73202 7.5 8.7319C7.49987 8.24177 7.59631 7.75609 7.78372 7.3033C7.97119 6.85034 8.24608 6.43878 8.59263 6.09209C8.93915 5.74545 9.35058 5.47039 9.80351 5.28273ZM19.0312 6.99854H11.232C11.0045 6.99854 10.7792 7.04335 10.569 7.13042C10.3589 7.21747 10.168 7.34511 10.0071 7.50605C9.84625 7.66696 9.71868 7.85797 9.63169 8.06816C9.54466 8.27842 9.49992 8.50372 9.5 8.73117L9.5 23.8915C9.5 24.3508 9.68249 24.7914 10.0073 25.1162C10.3322 25.4411 10.7727 25.6235 11.232 25.6235H21.768C22.2273 25.6235 22.6679 25.441 22.9927 25.1162C23.3175 24.7914 23.5 24.3509 23.5 23.8915V11.4685C23.5 11.4115 23.4888 11.355 23.467 11.3024C23.4452 11.2498 23.4132 11.2019 23.3729 11.1616L19.3389 7.12764L19.3375 7.12625C19.2973 7.08589 19.2495 7.05379 19.1968 7.03185C19.1442 7.00998 19.088 6.99868 19.0312 6.99854Z"
      fill="#00A1ED"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.889 5.52344C19.4413 5.52344 19.889 5.97115 19.889 6.52344V10.6115H24.1671C24.7193 10.6115 25.1671 11.0592 25.1671 11.6115C25.1671 12.1637 24.7193 12.6115 24.1671 12.6115H18.889C18.3368 12.6115 17.889 12.1637 17.889 11.6115V6.52344C17.889 5.97115 18.3368 5.52344 18.889 5.52344Z"
      fill="#00A1ED"
    />
  </svg>
);

export default Download;
